import { app } from '../../app.module'
app
  // ログアウト処理
  .directive('logout', ($cookies, $window) => {
    return {
      link: function ($scope: any) {
        // ログアウト処理
        $scope.executeLogout = function () {
          // セッションキーを破棄
          $cookies.remove('app_session_key')

          // ブラウザをリロード
          $window.location.reload()
        }
      },
    }
  })
